import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import Alert from "../../../Common/Alert";
import DatatableFunc from "../../../Common/DatatableFunc";
import Http from "../../../Common/Http";
import Swal from "sweetalert2";
import IsLogin from "../../../Common/IsLogin";
import { LoaderComponent } from "../../../Common/LoaderComponent";

const DailyProductionReport = () => {
  const location = useLocation();
  const [receiveData, setReceiveData] = useState({});
  const [alert, setAlert] = useState(null);
  const date = new Date();
  const month = date.getMonth() + 1;
  const year = date.getFullYear();
  const [inputs, setInputs] = useState({
    query_date: getCurrentDate(),
  });

  function getCurrentDate() {
    const dateObj = new Date();
    const month = ("0" + (dateObj.getMonth() + 1)).slice(-2);
    const day = ("0" + dateObj.getDate()).slice(-2);
    const year = dateObj.getFullYear();
    return `${year}-${month}-${day}`;
  }

  const handleChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setInputs((values) => ({ ...values, [name]: value }));
  };

  const fetchData = (dateParam) => {
    const dateValue = dateParam || inputs.query_date || getCurrentDate();
    Http.get(
      "/filter-cake-and-ball-charge-production?start_date=" +
        dateValue +
        "&end_date=" +
        dateValue
    ).then((res) => {
      setReceiveData(res.data);
    });
  };

  useEffect(() => {
    DatatableFunc();
    fetchData();
  }, []);

  const showAlert = (message, type) => {
    setAlert({
      message: message,
      type: type,
    });
    setTimeout(() => {
      setAlert(null);
    }, 4000);
  };

  useEffect(() => {
    if (!location.state) {
      return;
    }
    showAlert(location.state.message, location.state.type);
  }, [location]);

  const formSubmit = () => {
    fetchData(inputs.query_date);
  };

  return (
    <div>
      <IsLogin></IsLogin>
      <LoaderComponent />
      <div>
        <div className="am-mainpanel">
          <div className="am-pagetitle">
            <h5 className="am-title">Daily Production Report</h5>
          </div>
          <div className="am-pagebody">
            <Alert alert={alert} />
            <div className="card pd-20 pd-sm-40">
              <div className="row">
                <div className="col-3"></div>
                <div className="col-6">
                  <div className="row">
                    <div className="col-lg">
                      <input
                        type="date"
                        className="form-control margin-bottom-on-mobile"
                        name="query_date"
                        value={inputs.query_date || ""}
                        onChange={handleChange}
                        placeholder="Date"
                      />
                    </div>
                    <div className="col-lg">
                      <button
                        className="btn btn-primary btn-block mg-b-10"
                        onClick={formSubmit}
                      >
                        <i className="fa fa-send mg-r-10"></i> Search
                      </button>
                    </div>
                  </div>
                </div>
                <div className="col-3"></div>
              </div>
            </div>
          </div>
          <div className="am-pagebody">
            <div className="card pd-20 pd-sm-40">
              {/* <h6 className="card-body-title mg-sm-b-30">Datatable</h6> */}
              <div className="row">
                <div className="col-12">
                  <div className="text-center">
                    <h5 className="text-uppercase text-sm font-weight-bolder">
                      Artisan Ceramics Limited
                    </h5>
                    <p>
                      House-16, Road-07, Sector-01, Uttara, Dhaka
                      <br />
                      <b>Daily Production Report</b>
                      <br />
                      (Body)
                    </p>
                  </div>
                  <div className="text-center">
                    <h5 className="text-uppercase text-sm font-weight-bolder text-decoration-underline">
                      Ball Mill
                    </h5>
                  </div>
                  <div className="table-responsive p-0 pb-2">
                    <table className="table table-sm table-bordered table-striped align-items-center justify-content-center mb-0 _datatable">
                      <thead>
                        <tr>
                          <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                            Name of Body
                          </th>
                          <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                            Charge (Kg)
                          </th>
                          <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2 text-center">
                            Description
                          </th>
                          {/* <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2 text-center">
                            Discharge
                          </th>
                          <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2 text-center">
                            Remarks
                          </th> */}
                        </tr>
                      </thead>

                      <tbody>
                        {receiveData.ballMillCharges &&
                        receiveData.ballMillCharges.length > 0 ? (
                          receiveData.ballMillCharges.map((item, index) => (
                            <tr key={item.id || index}>
                              <td className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                                {item.name}
                              </td>
                              <td className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                                {item.charging_qty}
                              </td>
                              <td className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                                {item.description}
                              </td>
                              {/* <td className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                                {item.discharge}
                              </td>
                              <td className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                                {item.remarks}
                              </td> */}
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td
                              className="text-uppercase text-dark text-sm font-weight-bolder ps-2 text-center"
                              colSpan={5}
                            >
                              No data found
                            </td>
                          </tr>
                        )}
                        
                      </tbody>
                    </table>
                  </div>
                  <div className="text-center mt-5">
                    <h5 className="text-uppercase text-sm font-weight-bolder text-decoration-underline">
                      Filter Press
                    </h5>
                  </div>
                  <div className="table-responsive p-0 pb-2">
                    <table className="table table-sm table-bordered table-striped align-items-center justify-content-center mb-0 _datatable">
                      <thead>
                        <tr>
                          {/* <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                            Date
                          </th> */}
                          <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                            Code
                          </th>
                          <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2 text-center">
                            Name
                          </th>
                          <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2 text-center">
                            Qty
                          </th>
                          <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2 text-center">
                            Total Press Weight
                          </th>
                          <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2 text-center">
                            Remarks
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {receiveData.production &&
                        receiveData.production.length > 0 ? (
                          receiveData.production.map((item) => (
                            <tr key={item.id}>
                              {/* <td className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                                {item.date}
                              </td> */}
                              <td className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                                {item.code}
                              </td>
                              <td className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                                {item.name}
                              </td>
                              <td className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                                {item.qty}
                              </td>
                              <td className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                                {item.qty} X 20 = {item.weight}
                              </td>
                              <td className="text-uppercase text-dark text-sm font-weight-bolder ps-2"></td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td
                              className="text-uppercase text-dark text-sm font-weight-bolder ps-2 text-center"
                              colSpan={5}
                            >
                              No data found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DailyProductionReport;
